(function () {
  function shouldShowPopup() {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirect') === 'restricted';
  }

  function openPopup(popup) {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');

    // Force reflow so opening animation triggers
    popup.offsetHeight;

    popup.classList.add('is-opening');

    // Auto-close after 5 seconds
    setTimeout(function () {
      closePopup(popup);
    },5000);
  }

  function closePopup(popup) {
    popup.classList.remove('is-opening');
    popup.classList.add('is-closing');

    setTimeout(function () {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      popup.classList.remove('is-closing');
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('RestrictedAccessPopup');
    if (!popup) return;

    if (shouldShowPopup()) {
      openPopup(popup);
    }

    popup.addEventListener('click', function (e) {
      if (
        e.target.matches('[data-popup-close]') ||
        e.target.classList.contains('restricted-popup__overlay')
      ) {
        closePopup(popup);
      }
    });
  });
})();